module.exports = __webpack_public_path__ + "img/p38.fdfd05fb.gif";